import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import StoriesIndex from 'components/StoriesIndex'
import FavoritesPageActionPrompt from 'components/FavoritesPageActionPrompt'
import FavoritesDisplayNav from 'components/FavoritesDisplayNav'
import FeedSubscriptionsStore from 'stores/feed-subscriptions'
import StoriesStore from 'stores/stories'
import { useStore, useUserId } from 'hooks'
import { withFlow } from 'utils'

const FavoritesFeed = (props) => {
  const feedSubscriptionsStore = useStore(FeedSubscriptionsStore)
  const storiesStore = useStore(StoriesStore)
  const userId = useUserId()

  useEffect(() => {
    const op = withFlow(feedSubscriptionsStore.find(userId))
    return () => op.cancel()
  }, [userId])

  if (!feedSubscriptionsStore.items.length) {
    return storiesStore.isLoading ? null : <FavoritesPageActionPrompt type='add' />
  }

  return (
    <>
      <div className='container'>
        <FavoritesDisplayNav />
      </div>
      <StoriesIndex {...props} favoritesFeed />
    </>
  )
}

export default observer(FavoritesFeed)
